import { render, staticRenderFns } from "./superCollectPack.vue?vue&type=template&id=a3b73144&"
import script from "./superCollectPack.vue?vue&type=script&lang=js&"
export * from "./superCollectPack.vue?vue&type=script&lang=js&"
import style0 from "./superCollectPack.vue?vue&type=style&index=0&id=a3b73144&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports